// reserve-account.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ReservaGgrService } from 'src/app/components/reserva-ggr/reserva-ggr/reserva-ggr.service';

import { Observable, of, from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ReserveAccountGuard implements CanActivate {

  constructor(
    private auth: AuthService,
    private reservaSrv: ReservaGgrService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {

    /* 1. já temos a info em cache? */
    if (this.auth.hasReserveAccount()) {
      return of(true);
    }

    return from(this.reservaSrv.getAccount()).pipe(
      map((acc: any) => {
        const has = !!acc?.listsAccountTef?.length;
        this.auth.setReserveAccount(has);             
        return has ? true : this.router.parseUrl('/reports');
      }),
      catchError(() => of(this.router.parseUrl('/reports')))
    );
  }
}
